
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
// import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { FaRegTrashAlt } from 'react-icons/fa';
import { VscDiffAdded } from 'react-icons/vsc';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as bie from "react-bootstrap";
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG, MOBILE_VALIDATION } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from '../../CommonUtils/CommonValidations';

export default function InspectionDetails() {
    const hasFetchedData = useRef(false);
    const InspectionValidation = Yup.object({
        getTeamData: Yup.array().of(Yup.object().shape({
            officerName: Yup.string().required(ERROR_MSG).nullable(),
            deptCode: Yup.string().required(ERROR_MSG).nullable(),
            officerDesignation: Yup.string().required(ERROR_MSG).nullable(),
            presentlyWrkng: Yup.string().required(ERROR_MSG).nullable(),
            univAssocYears: Yup.string().required(ERROR_MSG).nullable(),
            mobileNo: Yup.string().required(ERROR_MSG).length(10, 'Mobile number must be  10 digits').matches(MOBILE_VALIDATION, 'Invalid mobile number'),
            officerWorkingAtOther: Yup.string().when('presentlyWrkng', {
                is: '9999',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),

        })),
    })

    const InspectionDetailsFormik = useFormik({
        initialValues: {
            getTeamData: [
                {
                    officerName: "",
                    deptCode: "",
                    officerDesignation: "",
                    presentlyWrkng: "",
                    aadhar: "",
                    univIssuedIdNo: "",
                    cfmsIdNo: "",
                    univAssocYears: "",
                    mobileNo: "",
                    officerWorkingAtOther: "",
                }
            ]
        },
        enableReinitialize: true,
        // InspectionValidation,
        onSubmit: (values) => {
            let isValid = true;
            let invalidRowIndex = -1;
            values.getTeamData = values.getTeamData.map((item, index) => {
                item.univAssocYears = parseInt(item.univAssocYears, 10) || '';
                item.mobileNo = parseInt(item.mobileNo, 10) || '';
                item.deptCode = parseInt(item.deptCode, 10) || '';
                item.mobileNo = item.mobileNo || '';
                item.aadhar = item.aadhar || '';
                const missingFields = [];
                if (!item.officerName) missingFields.push("Officer Name");
                if (!item.deptCode) missingFields.push("Department Name");
                if (!item.officerDesignation) missingFields.push("Officer Designation");
                if (!item?.presentlyWrkng) missingFields.push("Present Working");
                // if (!item.aadhar) missingFields.push("Aadhar Number");
                // if (item.aadhar && !AADHAR_VALIDATION.test(item.aadhar)) { missingFields.push("Aadhar Number is invalid"); }
                if (!item.univIssuedIdNo) missingFields.push("University Issued ID");
                // if (!item.cfmsIdNo) missingFields.push("CFMS ID");
                if (!item.univAssocYears) missingFields.push("University Association Years");
                if (!item.mobileNo) missingFields.push("Mobile Number");
                if (item.mobileNo && !MOBILE_VALIDATION.test(item.mobileNo)) { missingFields.push("Mobile Number is invalid"); }
                if (missingFields.length > 0) {
                    isValid = false;
                    invalidRowIndex = index;
                    item.missingFields = missingFields;
                }

                return item;
            });


            values?.getTeamData?.forEach(officer => {
                delete officer.missingFields;
            });
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.FAC_URL}saveFfcaMemDetails`;
                    CommonAxiosPost(url, values?.getTeamData).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetTeamData();
                        } else {
                            failureAlert("Submission Failed.");
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })



    const [UnivData, setUnivData] = useState([]);
    function GetUniversityDetails() {
        let url = config.url.FAC_URL + `getUniversitiesData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUnivData(res?.data?.Universities)

            } else {
                setUnivData([])

            }
        })
    }

    const [DesignationData, setDesignationData] = useState([]);
    function GetDesignationData() {
        let url = config.url.FAC_URL + `getDesignationsData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {

                setDesignationData(res?.data?.Designations)

            } else {
                setDesignationData([])

            }
        })
    }


    const [DeptData, setDeptData] = useState([]);
    function GetDepartmentDetails() {
        let url = config.url.FAC_URL + `getDepartmentData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {

                setDeptData(res?.data?.Departments)

            } else {
                setDeptData([])

            }
        })
    }
    const [TeamHeadData, setTeamHeadData] = useState([]);
    function GetTeamHeadDetails() {
        let url = config.url.FAC_URL + "getTeamHeadData";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setTeamHeadData(res?.data?.TeamHeadData)

            } else {
                setTeamHeadData([])

            }
        })
    }
    function GetTeamData() {
        let url = config.url.FAC_URL + "getTeamData";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                res?.data?.TeamData?.forEach((data, i) => {
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].officerName`, data?.officer_name);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].deptCode`, data?.dept_code);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].officerDesignation`, data?.officer_designation);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].presentlyWrkng`, data?.presently_wrkng);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].aadhar`, data?.aadhar);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].univIssuedIdNo`, data?.univ_issued_id_no);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].cfmsIdNo`, data?.cfms_id_no);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].univAssocYears`, data?.univ_assoc_years);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].mobileNo`, data?.mobile_no);
                    InspectionDetailsFormik?.setFieldValue(`getTeamData[${i}].officerWorkingAtOther`, data?.officer_working_at_other);


                })

            } else {
                InspectionDetailsFormik?.setFieldValue("getTeamData", [{
                    officerName: "",
                    deptCode: "",
                    officerDesignation: "",
                    presentlyWrkng: "",
                    aadhar: "",
                    univIssuedIdNo: "",
                    cfmsIdNo: "",
                    univAssocYears: "",
                    mobileNo: "",
                    officerWorkingAtOther: "",
                }]);


            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetTeamData();
            GetTeamHeadDetails();
            GetUniversityDetails();
            GetDesignationData();
            GetDepartmentDetails();
            hasFetchedData.current = true
        }

    }, [])

    return (
        <>
            {/* <CommonFormHeading heading="FFCA TEAM DETAILS" /> */}

            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={InspectionDetailsFormik}>
                        <Form onChange={InspectionDetailsFormik.handleChange} onSubmit={InspectionDetailsFormik.handleSubmit} className='affl-form'>
                            <bie.Row className="px-2 mb-2 pt-0">
                                {/* {TeamHeadData?.length > 0 ? (<> */}
                                <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className='mb-0'>Team Head Details:-</h1>
                                    </div>
                                    <div class="card-body RowColorForLeave">
                                        <bie.Row className='px-2 my-3'>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1"> Officer Name:</label>
                                                <Field type="text" name="officername" className="form-control mb-2" disabled value={TeamHeadData[0]?.officer_name || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1">Department Name:
                                                </label>
                                                <Field type="text" name="departmentname" className="form-control mb-2" disabled value={TeamHeadData[0]?.board_discipline_group || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1">Officer designation:
                                                </label>
                                                <Field type="text" name="officerdesignation" className="form-control mb-2" disabled value={TeamHeadData[0]?.designation_name || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1">Presently Working At:</label>
                                                <Field type="text" name="presentwork" className="form-control mb-2" disabled value={TeamHeadData[0]?.presently_wrkng || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1"> Aadhaar:</label>
                                                <Field type="text" name="adhaar" className="form-control mb-2" disabled value={TeamHeadData[0]?.aadhar || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1">University Issued ID No:
                                                </label>
                                                <Field type="text" name="universityissueid" className="form-control mb-2" disabled value={TeamHeadData[0]?.univ_issued_id_no || '-'} />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1">CFMS ID:</label>
                                                <Field type="text" name="cfmsid" className="form-control mb-2" disabled value={TeamHeadData[0]?.cfms_id_no || '-'} />
                                            </bie.Col>


                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={4}>
                                                <label className="mb-1">No of years of association with the university:
                                                </label>
                                                <Field type="text" name="yearsassociatewithuni" className="form-control mb-2" disabled value={TeamHeadData[0]?.univ_assoc_years || '-'} />
                                            </bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1"><b>Mobile No:</b>
                                                </label>
                                                <Field type="text" name="mobilenumber" className="form-control mb-2" disabled value={TeamHeadData[0]?.mobile_no || '-'} />
                                            </bie.Col>
                                            {/* <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        <label className="mb-1"> <b>inspec_date_colleges:</b>&nbsp; <i style={{ textAlign: "justify" }}>{TeamHeadData?.inspec_date_colleges}</i></label>
                                    </bie.Col>  */}

                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                                <label className="mb-1"> <b>Date of Inspection:</b>&nbsp; <i style={{ textAlign: "justify" }}></i></label>
                                                <Field type="text" name="dateinspection" className="form-control mb-2" disabled value={TeamHeadData[0]?.date_of_inspec || '-'} />
                                            </bie.Col>
                                        </bie.Row>
                                    </div>

                                </bie.Col>
                                {/* </>) : (<> <center className='text-danger h5 pt-5'>***** No Data Found *****</center></>)} */}
                            </bie.Row>
                            {/* {TeamHeadData.length > 0 ? (<> */}
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">

                                    <thead>
                                        <tr>
                                            <th> S.No</th>
                                            <th> Officer Name</th>
                                            <th> Department</th>
                                            <th>Officer Designation</th>
                                            <th> Presently Working at University </th>
                                            <th>Aadhaar</th>
                                            <th>Issued Id No	</th>
                                            <th>CFMS Id No</th>
                                            <th> No of years of association with the university</th>
                                            <th>	Contact No</th>
                                            <th>Action</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        <FieldArray name="getTeamData">
                                            {(QualificationValues) => {
                                                return QualificationValues?.form?.values?.getTeamData.map((qual, index) => {
                                                    return (
                                                        <>
                                                            <tr key={index}>
                                                                <td>
                                                                    <center>{index + 1}</center>
                                                                </td>
                                                                <td>
                                                                    <Field type="text" maxLength="30"
                                                                        onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].officerName`}
                                                                        style={{ width: '12rem' }} />
                                                                    <ErrorMessage name={`getTeamData[${index}].officerName`} component="div" className="text-error" />


                                                                </td>
                                                                <td>
                                                                    <Field as="select"
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].deptCode`}
                                                                        style={{ width: '12rem' }}>
                                                                        <option value=''>--select--</option>
                                                                        {DeptData && DeptData.map((dept, i) => (
                                                                            <option value={dept?.board_discipline_group_id}>{dept?.board_discipline_group}</option>
                                                                        ))}

                                                                    </Field>

                                                                    <ErrorMessage name={`getTeamData[${index}].deptCode`} component="div" className="text-error" />

                                                                </td>
                                                                <td>
                                                                    <Field as="select"
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].officerDesignation`}
                                                                        style={{ width: '12rem' }}>
                                                                        <option value=''>--select--</option>
                                                                        {DesignationData && DesignationData.map((desig, i) => (
                                                                            <option value={desig?.desig_code}>{desig?.designation_name}</option>
                                                                        ))}
                                                                    </Field>
                                                                    <ErrorMessage name={`getTeamData[${index}].officerDesignation`} component="div" className="text-error" />

                                                                </td>
                                                                <td>
                                                                    <Field as="select"
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].presentlyWrkng`}
                                                                        style={{ width: '12rem' }}
                                                                        onChange={(e) => {
                                                                            const selectedValue = e.target.value;

                                                                            if (selectedValue !== "9999") {
                                                                                InspectionDetailsFormik.setFieldValue(`getTeamData[${index}].officerWorkingAtOther`, "");
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value=''>--select--</option>
                                                                        {UnivData && UnivData?.map((univ, i) => (
                                                                            <option value={univ?.ub_code}>{univ?.ub_name}</option>
                                                                        ))}
                                                                        <option value="9999">Other University</option>
                                                                    </Field> <br />
                                                                    <ErrorMessage name={`getTeamData[${index}].presentlyWrkng`} component="div" className="text-error" />


                                                                    {InspectionDetailsFormik?.values?.getTeamData?.[index]?.presentlyWrkng === "9999" && (<>

                                                                        <Field type="text" name={`getTeamData[${index}].officerWorkingAtOther`} className="form-control mb-2"
                                                                            onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} maxLength={200} />
                                                                        <ErrorMessage name={`getTeamData[${index}].officerWorkingAtOther`} component="div" className="text-error" />
                                                                    </>)}


                                                                </td>
                                                                <td>
                                                                    <Field type="text"
                                                                        onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                                        maxLength={12} onPaste={(e) => handlePaste(e)}
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].aadhar`}
                                                                        style={{ width: '10rem' }} />
                                                                    {/* <ErrorMessage name={`getTeamData[${index}].aadhar`} component="div" className="text-error" /> */}


                                                                </td>
                                                                <td>
                                                                    <Field type="text"
                                                                        className="form-control form-control-md"
                                                                        maxLength="10"
                                                                        name={`getTeamData[${index}].univIssuedIdNo`}
                                                                        style={{ width: '10rem' }} />
                                                                    {/* <ErrorMessage name={`getTeamData[${index}].univIssuedIdNo`} component="div" className="text-error" /> */}


                                                                </td>  <td>
                                                                    <Field type="text" maxLength="10" onPaste={(e) => handlePaste(e)}
                                                                        onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                                        className="form-control form-control-md"
                                                                        name={`getTeamData[${index}].cfmsIdNo`}
                                                                        style={{ width: '10rem' }} />
                                                                    {/* <ErrorMessage name={`getTeamData[${index}].cfmsIdNo`} component="div" className="text-error" /> */}


                                                                </td>  <td>
                                                                    <Field type="text" className="form-control form-control-md"
                                                                        maxLength={2} onPaste={(e) => handlePaste(e)}
                                                                        name={`getTeamData[${index}].univAssocYears`}
                                                                        onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                                        style={{ width: '5rem' }} />

                                                                    <ErrorMessage name={`getTeamData[${index}].univAssocYears`} component="div" className="text-error" />


                                                                </td>

                                                                <td>
                                                                    <Field type="text"
                                                                        className="form-control form-control-md"
                                                                        maxLength={10} onPaste={(e) => handlePaste(e)}
                                                                        name={`getTeamData[${index}].mobileNo`}
                                                                        onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                                        style={{ width: '12rem' }} />
                                                                    <ErrorMessage name={`getTeamData[${index}].mobileNo`} component="div" className="text-error" />


                                                                </td>

                                                                <td colSpan={2} align="center" className="col-md-1">
                                                                    {/* {(InspectionDetailsFormik?.values.getTeamData.length >1) ? ( */}
                                                                    {index > 0 && InspectionDetailsFormik?.values.getTeamData.length > 1 ? (
                                                                        <button
                                                                            type="button"
                                                                            className="button-titile btn btn-sm btn-danger"
                                                                            onClick={() => QualificationValues.remove(index)} >
                                                                            <FaRegTrashAlt />
                                                                        </button>
                                                                    ) : <td></td>}

                                                                </td>

                                                            </tr>
                                                        </>
                                                    );
                                                });
                                            }}
                                        </FieldArray>
                                        <tr className='table-active'>
                                            <td className='text-end' colSpan={11} >
                                                <FieldArray name="getTeamData">
                                                    {(formikFieldArray) => {
                                                        return formikFieldArray.form.values.getTeamData.map((LJP, i) => {
                                                            return (<>
                                                                {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-primary btn-success"
                                                                    onClick={() => {
                                                                        formikFieldArray.push({
                                                                            officerName: "",
                                                                            deptCode: "",
                                                                            officerDesignation: "",
                                                                            presentlyWrkng: "",
                                                                            aadhar: "",
                                                                            univIssuedIdNo: "",
                                                                            cfmsIdNo: "",
                                                                            univAssocYears: "",
                                                                            officerWorkingAtOther: "",
                                                                            mobileNo: "",
                                                                        });
                                                                    }}>
                                                                    <VscDiffAdded></VscDiffAdded>
                                                                </button> </> : ''}
                                                            </>)
                                                        })
                                                    }}
                                                </FieldArray>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="button-cend pt-3 mb-3">
                                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit Team Details</button>
                            </div>
                            {/* </>) : (<></>)} */}
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>

        </>
    )
}
